import loadable from '@loadable/component';

export const loadablePage = modulePath => {
  return loadable(() =>
    import(/* webpackPrefetch: true */ `content/${modulePath}`)
  );
};
